import { Component, OnInit } from '@angular/core';
import { Router, RouterOutlet, RouterModule, NavigationEnd } from '@angular/router';
import { CommonModule } from '@angular/common';
import { PrimeNgModule } from './shared/prime-ng.module';
import { HeaderComponent } from './header/header.component';
import { ApplicationDataService } from './services/application-data.service';
import { AuthService } from './services/auth.service';
import { ClientService } from './services/client.service';
import { ProjectService } from './services/project.service';
import { filter, Subscription } from 'rxjs';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterModule, PrimeNgModule, HeaderComponent],
  providers: [ApplicationDataService, AuthService, ClientService],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  public url = '';
  public isLogin = false
  private routerSubscription: Subscription = new Subscription();
  currentUrl: string = '';
  constructor(
    private router: Router,
  ) { }
  title = 'csr';

  public isLoad = true;
  ngOnInit() {
    this.url = this.router.url;
    const userCode = sessionStorage.getItem('user_code');
    this.isLogin = userCode !== null && this.url !== '/login';
    setTimeout(() => {
      this.isLoad = false;
    }, 5000);
    this.currentUrl = this.router.url;
    this.routerSubscription = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.currentUrl = event.urlAfterRedirects || event.url;
        const userCode = sessionStorage.getItem('user_code');
        this.isLogin = userCode !== null && this.currentUrl !== '/login';
      });
  }

  componentAdded(event: any) {
    this.url = this.router.url;
    let uCode = sessionStorage.getItem('user_code');
    if (this.url !== '/login' && uCode !== null) {
      this.isLogin = true;
    } else if (this.url === '/login') {
      this.isLogin = false;
    } else {
      this.isLogin = false;
    }
  }
}